import { EnhancedRouteProps } from 'router/routes/Enhanced/Enhanced.route';
import NotFoundPage from 'router/subrouters/Dash/pages/NotFoundPage';
import RwcAnalyticsLayout from './components/RwcAnalyticsLayout';
import Configuration from '../Configuration';
import Branding from '../Branding';

const rwcEnterpriseRoutes = [
  {
    path: 'configuration',
    element: Configuration,
  },
  {
    path: 'branding',
    element: Branding,
  },
  { index: true, element: RwcAnalyticsLayout },
  { path: '*', element: NotFoundPage },
] as Array<EnhancedRouteProps>;

export default rwcEnterpriseRoutes;
